import React, {useEffect} from 'react';

const ReportModal: React.FC<{
  open: boolean;
  variant?: 'preparing' | 'success';
  reportId?: string;
  onClose?: () => void;
  onDownload?: () => void;
}> = ({
  open,
  variant = 'preparing',
  reportId = 'BC-PCF-2026-579555',
  onClose,
  onDownload
}) => {
  // Lock body scroll while open
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [open]);

  // Esc key closes
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);

    return () => {
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const isPreparing = variant === 'preparing';

  return (
    <div className="report-modal-backdrop" onClick={onClose}>
      <div
        className="report-modal-card"
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
        }}
        role="dialog"
        aria-modal="true"
      >
        {/* Top icon */}
        <div className="report-modal-icon">
          {isPreparing ? (
            // Spinner ring
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              className="report-spinner"
            >
              <circle
                cx="28"
                cy="28"
                r="22"
                fill="none"
                stroke="#E5E7EB"
                strokeWidth="4"
              />
              <circle
                cx="28"
                cy="28"
                r="22"
                fill="none"
                stroke="#3F7D3F"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray="40 100"
                transform="rotate(-90 28 28)"
              />
            </svg>
          ) : (
            // Success check inside outlined circle
            <svg width="56" height="56" viewBox="0 0 56 56">
              <circle
                cx="28"
                cy="28"
                r="22"
                fill="none"
                stroke="#3F7D3F"
                strokeWidth="2.5"
              />
              <path
                d="M18 28 L25 35 L38 22"
                fill="none"
                stroke="#3F7D3F"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>

        {/* Title */}
        <h3 className="report-modal-title">
          {isPreparing
            ? 'Report Package Prepared'
            : 'Report Generated Successfully!'}
        </h3>

        {/* Report ID line */}
        <p className="report-modal-meta">
          Report ID: <span className="report-modal-id">{reportId}</span>
        </p>

        {/* CTA */}
        <div className="report-modal-actions">
          {isPreparing ? (
            <button className="report-modal-btn" onClick={onClose}>
              Close
            </button>
          ) : (
            <button className="report-modal-btn" onClick={onDownload}>
              Download Report
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
